module.exports = __webpack_public_path__ + "static/gallery04-57fd97f0e1e479458444c7b4ed9d67dc.jpg";